
class NavFooter {

    constructor() {
        this.container = document.querySelector('.nav-footer');

        this.registerListeners();
    }

    registerListeners() {
        const instance = this;

        this.container.querySelectorAll('.link-section > .column > .list-heading')
            .forEach((heading) => {
                heading.addEventListener('click', e => instance.handleColumnHeaderClicked(e));
        })
    }

    handleColumnHeaderClicked(e) {
        e.target.classList.toggle('closed');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.navFooter = new NavFooter();
})